export const NOT_AVAILABLE = 'NA';

export const GA4_BOT_CHANNEL_WEB = 'web';

export const GA4_BOT_CHANNEL_MOBILE = 'mobile';

export const BOT_SESSION_TOPIC_EVENT = 'bot_session_topic';

export const BOT_ESCALATED_SESSION_EVENT = 'bot_escalated_session';

export const DIBOT_INTERACTION_WITH = 'Asistente Virtual';

export const DIBOT_SESSION_ID_KEY = 'dibot_session_id';

export const PRODUCTOS_DATA_ID = 'productosData';

export const SKU_HEADER_REGEX = /\bsku\b/i;

export const RECOMMENDATION_HEADER_REGEX = /te puede interesar|alternativ|similar/i;

export const SKU_INPUT_REGEX = /^\d{4,7}$/;
